<template><div style="min-height: 100vh" class="d-flex justify-center">

	<v-flex style="max-width: 600px" xs12 pa-5>

		<div class="d-flex pt-sm-5">

		    <v-text-field
				ref="search_field"
		        dense :autofocus="!$vuetify.breakpoint.xs" disable
	        	rounded solo dense clearable
				:placeholder="'Search a word in English or Nao' | t"
				@keydown.enter="search(cur_input)"
				@keydown.escape="clear()"
				@click:clear="clear()"
				v-model="cur_input"
	        ></v-text-field>
	        <v-btn @click="search(cur_input)" class="mx-2" fab dark small color="primary"><v-icon dark> {{ $mdi.Magnify }} </v-icon></v-btn>

		</div>

		<div v-if="search_word">
		
			<div v-for="f in ['to_Nao','from_Nao']">
				<div v-if="f=='to_Nao' && tr_obj[f].length > 1" class="font-weight-light pr-2">
					{{ $t("We have found $n translations. Choose the one that fits your context:", {n: tr_obj[f].length }) }}
				</div>
				<div v-else-if="f=='from_Nao' && tr_obj.from_Nao.length > 0 && tr_obj.to_Nao.length > 0" class="font-weight-light pr-2 pt-4">
				Translating from Nao: </div>

				<v-layout v-for="(w,index) in tr_obj[f]" class="ma-1">
					<div v-if="tr_obj[f].length > 1" class="py-1 pr-3 text--secondary"> {{index+1}} </div>

					<div>
						<div>
							<span :class="$css.naoword"> {{ w.nao }} </span>
							<v-tooltip right>
						      <template v-slot:activator="{ on, attrs }">
						      	<v-btn @click="$nao.pronounce($nao.disassemble(w.nao))" v-bind="attrs" v-on="on" icon><v-icon> {{ $mdi.VolumeHigh }} </v-icon></v-btn>
						      </template>
						      <span>Pronounce</span>
						    </v-tooltip>

						    <v-btn
						    	v-if="$nao.disassemble(w.nao).length > 1"
						    	@click="$show_disassemble(w.nao)"
						    	icon
						    ><v-icon> {{ $mdi.TableSplitCell }} </v-icon></v-btn>
						</div>

						<div>
							<span> {{ w.main_tr }} </span>
						</div>
						<div v-if="w.other_tr && f=='from_Nao'">
							<span class="font-weight-light pr-2" > {{ "Possible translations" | t }}: </span>
							<span class="text--secondary"> {{ w.other_tr.join('; ') }} </span>
						</div>
						<v-card v-if="w.color" class="colorbox" :elevation="8" :style="'background-color: ' + w.color"> </v-card>
					</div>
				</v-layout>

			</div>

			<div v-if="tr_obj.from_Nao.length == 0 && tr_obj.to_Nao.length == 0"> Nothing found </div>
		</div>

		<div v-show="$ls.search_history.length > 0" id="history">
		<div class="d-flex justify-center"><div style="width: 100%; max-width: 600px" class="d-flex">
			<v-btn v-if="gotta_show_buttons" @click="scroll(-1)" icon><v-icon> {{ $mdi.ArrowLeft }} </v-icon></v-btn>
			<div ref="container" id="container"><div ref="flexscroll" id="flex-scroll">
				<v-chip @click="search(w)" v-for="w in $ls.search_history"> {{w}} </v-chip>
			</div></div>
			<v-btn v-if="gotta_show_buttons" @click="scroll(1)" icon><v-icon> {{ $mdi.ArrowRight }} </v-icon></v-btn>
			</button>
		</div></div>
		</div>

	</v-flex>


<v-snackbar
  v-model="msg_cannot_use_dict"
>
  No cheating! Game in progress
  <template v-slot:action="{ attrs }">
    <v-btn
      color="pink"
      text
      v-bind="attrs"
      @click="msg_cannot_use_dict = false"
    >
      Close
    </v-btn>
  </template>
</v-snackbar>

</div></template>

<script>

let resize_ob;
let fuck_this;

import Element from '@/components/Element'

export default {
	components: {Element},
	data() {
		return {
			disassemble_dialog: false,
			cur_input: '',
			dis: [],
			autocomplete_disabled: true,
		    gotta_show_buttons: true,
		    msg_cannot_use_dict: false,
		    search_word: '',
		}
	},
	watch: {
		$route(nv, ov) {
			this.set_search_word();
		}
	},
	mounted() {
		//this.$ls.write('search_history', []);
		resize_ob = new window.ResizeObserver(this.handleResize);
		resize_ob.observe(this.$refs.container);
	},
	created() {
		this.set_search_word();
	},
	beforeDestroy() {
		resize_ob.unobserve(this.$refs.container);
	},
	computed: {
		tr_obj() {
			let kk = this.$store.state.language;

			let tr = this.$nao.tr_from_and_to_Nao(this.search_word);

			if (tr.from_Nao.length > 0 || tr.to_Nao.length > 0) {
				let A = this.$ls.search_history;
				let i = A.indexOf(this.search_word);
				if (i >= 0) A.splice(i, 1);

				A.push(this.search_word);
				if (A.length > 30) A.shift();
			}

			return tr;
		},
	},
	methods: {
		search(w) {
			if (!w) return;
	
			if (this.$refs.search_field && this.$vuetify.breakpoint.xs) this.$refs.search_field.blur();

			let word = w.trim().replace(/ +/g, '_');
			this.change_url(word);
		},
		clear() {
			this.change_url("");
		},
		change_url(word) {
			this.$router.push({name: 'dict', params: {word} }).catch(err => {});
		},
		set_search_word() {
			if (new Date().getTime() - localStorage.game_in_progress < 2000) {
				this.msg_cannot_use_dict = true;
				this.search_word = this.cur_input = '';
				return;
			}

			let w = this.$route.params.word || '';
			
			this.search_word = this.cur_input = w.replace(/_/g, ' ');

			if (search_word == "arab") {
				this.$vuetify.rtl = true;
				setTimeout(() => {
					this.$vuetify.rtl = false;
				}, 60000);
			}
		},
		scroll(n) {
			this.$refs.container.scroll({
				left: this.$refs.container.scrollLeft+n*200,
				behavior: 'smooth'
			});
		},
		handleResize() {
			this.gotta_show_buttons = parseFloat(window.getComputedStyle(this.$refs.flexscroll).width) > parseFloat(window.getComputedStyle(this.$refs.container).width);
		}
	}
}
</script>

<style scoped>

#history {
	width: 100%;
	position: fixed;
	left: 0;
	bottom: 0;
}

#history .v-chip {
	user-select: none;
	xfont-weight: 200;
	color: grey;
}

#history .v-chip:hover {
	cursor: pointer;
	color: black;
}

#container {
	display: flex;
	overflow: auto;
	-ms-overflow-style: none;  /* IE and Edge */
	scrollbar-width: none;  /* Firefox */
}

#container::-webkit-scrollbar {
    display: none;
}


#flex-scroll {
	flex-direction: row-reverse;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: nowrap;
}

.colorbox {
	height: 30px;
	width: 60px;
	border-radius: 10px;
}

</style>